<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="businessProfile"
  >
    <v-card height="70%" flat tile>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Business Profile Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-sheet height="90%">
        <v-container class="fill-height align-start" fluid>
          <v-row align="start">
            <v-col cols="12">
              <v-list color="transparent">
                <v-list-item class="pl-0 pr-0">
                  <UserAvatar :usersInitials="businessProfile.businessName[0]">
                  </UserAvatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium"
                      >{{ businessProfile.businessName }} &ensp;
                      <v-chip
                        v-if="businessProfile.subscriptionStatus"
                        label
                        :color="
                          getStatusColor(businessProfile.subscriptionStatus) +
                          '--text ' +
                          getStatusColor(businessProfile.subscriptionStatus) +
                          ' lighten-5'
                        "
                        class="font-weight-medium text-capitalize ml-2"
                        dark
                        small
                        >{{ businessProfile.subscriptionStatus }}</v-chip
                      >
                      <v-chip
                        v-else
                        label
                        color="orange--text  orange  lighten-5"
                        class="font-weight-medium text-capitalize ml-2"
                        dark
                        small
                        >Pending</v-chip
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >{{ businessProfile.country }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0">
              <!---Start: Aggregate cards---->
              <v-card flat class="py-0">
                <v-card-text class="d-flex justify-start px-0 py-0">
                  <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                    <v-list-item>
                      <IconContainer size="50" imagePath="badge.png" />

                      <v-list-item-content class="ml-2">
                        <v-list-item-subtitle
                          >Total Business Cards</v-list-item-subtitle
                        >
                        <v-list-item-title class="text-h6">{{
                          businessCards.length
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>

                  <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                    <v-list-item>
                      <IconContainer imagePath="teamwork.png" size="50" />

                      <v-list-item-content class="ml-2">
                        <v-list-item-subtitle
                          >Total App Accounts</v-list-item-subtitle
                        >
                        <v-list-item-title class="text-h6"
                          >{{ associatedUsers.length }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-card-text>
              </v-card>
              <!---End: Aggregate cards---->
            </v-col>
            <v-col cols="12">
              <v-tabs v-model="tab">
                <v-tab class="text-capitalize">Business Cards</v-tab>
                <v-tab class="text-capitalize">Business Portal Access</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-data-table
                    :headers="businessCardHeaders"
                    :items="businessCards"
                    :items-per-page="8"
                  >
                    <template v-slot:item.avatar="{ item }">
                      <UserAvatar
                        :key="`avatar${item.email}`"
                        :usersInitials="item.firstName[0] + item.lastName[0]"
                        :displayImageUrl="item.displayImageUrl || ''"
                      />
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        label
                        :color="
                          getStatusColor(item.status) +
                          '--text ' +
                          getStatusColor(item.status) +
                          ' lighten-5'
                        "
                        class="font-weight-medium text-capitalize"
                        dark
                        small
                        >{{ item.status }}</v-chip
                      >
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <!-- <BusinessPortalAccess
                    ref="businessPortalAccess"
                    :businessProfileId="businessProfileId"
                    :selectedBusinessProfileId="businessProfileId"
                    :businessProfile="businessProfile"
                  /> -->
                  <v-data-table
                    :headers="associatedUsersHeaders"
                    :items="associatedUsers"
                    :items-per-page="8"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        label
                        :color="
                          getStatusColor(item.status) +
                          '--text ' +
                          getStatusColor(item.status) +
                          ' lighten-5'
                        "
                        class="font-weight-medium text-capitalize"
                        dark
                        small
                        >{{ item.status }}</v-chip
                      >
                    </template>
                    <template v-slot:item.privilegeLevel="{ item }">
                      <span class="text-capitalize">{{
                        item.privilegeLevel
                      }}</span>
                    </template>
                    <template v-slot:item.platform="{ item }">
                      {{ getPlatform(item) }}
                    </template>
                    <!-- Start: comment <template v-slot:item.lastLoginDate="{ item }">
                      {{
                        item.lastLoginDate
                          ? item.lastLoginDate.toDate().toLocaleDateString()
                          : "-"
                      }}
                    </template> 
                    <template v-slot:item.lastLoggedInPlatform="{ item }">
                      {{
                        item.lastLoggedInPlatform
                          ? formatLastLoggedInPlatform(
                              item.lastLoggedInPlatform
                            )
                          : "-"
                      }}
                    </template> End: comment  -->
                    <template v-slot:item.activePlatforms="{ item }">
                      <div class="d-flex justify-space-around">
                        <v-icon
                          size="22"
                          class="mr-2"
                          :color="
                            item.hasLoggedInToAndroid
                              ? 'primary'
                              : 'grey lighten-1'
                          "
                          >mdi-android</v-icon
                        >
                        <v-icon
                          size="22"
                          :color="
                            item.hasLoggedInToIos ? 'primary' : 'grey lighten-1'
                          "
                          class="mr-2"
                          >mdi-apple</v-icon
                        >
                        <v-icon
                          size="22"
                          :color="
                            item.hasLoggedInToWeb ? 'primary' : 'grey lighten-1'
                          "
                          class="mr-2"
                          >mdi-xml</v-icon
                        >
                        <v-icon
                          size="22"
                          :color="
                            item.hasLoggedInToBusinessPortal
                              ? 'primary'
                              : 'grey lighten-1'
                          "
                          >mdi-briefcase</v-icon
                        >
                      </div>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import IconContainer from "@/components/IconContainer";
import BusinessPortalAccess from "@/components/BusinessPortalAccess";

export default {
  props: {
    show: { type: Boolean, default: false },
    cardholders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    users: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessProfiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessProfileId: { type: String, default: "" },
    businessPortalAccess: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    UserAvatar,
    IconContainer,
    BusinessPortalAccess,
  },
  computed: {
    businessProfile() {
      let businessProfile = this.businessProfiles.find(
        (businessProfile) => businessProfile.id == this.businessProfileId
      );
      return businessProfile;
    },
    businessCards() {
      let businessCards = this.cardholders.filter((cardholder) => {
        return cardholder.businessProfileId == this.businessProfile.id;
      });
      return businessCards;
    },
    associatedUsers() {
      let associatedUsers = this.businessPortalAccess.filter((item) => {
        return item.businessProfileId == this.businessProfile.id;
      });
      return associatedUsers;
    },
  },
  data() {
    return {
      tab: 0,
      businessCardHeaders: [
        {
          text: "",
          align: "right",
          value: "avatar",
          sortable: false,
        },
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Subscription type",
          align: "left",
          value: "subscriptionType",
        },
        {
          text: "Status",
          align: "left",
          value: "status",
        },
      ],
      associatedUsersHeaders: [
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Privilege Level",
          align: "left",
          value: "privilegeLevel",
        },

        {
          text: "Status",
          align: "left",
          value: "status",
        },
        // {
        //   text: "Last Logged In",
        //   align: "left",
        //   value: "lastLoginDate",
        // },
        // {
        //   text: "Last Logged in Platform",
        //   align: "left",
        //   value: "lastLoggedInPlatform",
        // },
        {
          text: "Platform",
          align: "left",
          value: "platform",
        },
        {
          text: "",
          align: "left",
          value: "activePlatforms",
        },
      ],
      search: "",
    };
  },
  destroyed() {
    console.log("dsestroyed called in bp details");
  },
  methods: {
    getStatusColor(status) {
      if (status) {
        if (
          status.toLowerCase() == "active" ||
          status.toLowerCase() == "trialing"
        )
          return "green";
        else if (status.toLowerCase() == "pending") return "orange";
        else if (status.toLowerCase() == "declined") return "red";
        else return "red";
      }
    },
    formatLastLoggedInPlatform(platform) {
      switch (platform) {
        case "ios":
          return "iOS";
        case "android":
          return "Android";
        case "web":
          return "Web";
        case "business-portal":
          return "Business Portal";
        default:
          return "-";
      }
    },
    getPlatform(user) {
      let platform = "";

      if (
        (user.lastLoginDate == undefined || user.lastLoginDate == "") &&
        (user.lastLoggedInPlatform == undefined ||
          user.lastLoggedInPlatform == "")
      )
        return "-";
      else {
        platform = user.lastLoginDate
          ? user.lastLoginDate.toDate().toLocaleDateString()
          : "";

        //Add 'the' before Business Portal
        if (user.lastLoggedInPlatform == "business-portal")
          platform += " on the ";
        else platform += " on ";

        platform += user.lastLoggedInPlatform
          ? this.formatLastLoggedInPlatform(user.lastLoggedInPlatform)
          : "-";
        return platform;
      }
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>